var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { createElement } from "react";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { ToolboxToolViewModel } from "survey-creator-core";
import { attachKey2click, ReactElementFactory, SvgIcon } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
var SurveyCreatorToolboxTool = /** @class */ (function (_super) {
    __extends(SurveyCreatorToolboxTool, _super);
    function SurveyCreatorToolboxTool(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    SurveyCreatorToolboxTool.prototype.createModel = function (props) {
        this.model = new ToolboxToolViewModel(props.item, props.creator, props.parentModel);
    };
    SurveyCreatorToolboxTool.prototype.getUpdatedModelProps = function () {
        return ["creator", "item"];
    };
    Object.defineProperty(SurveyCreatorToolboxTool.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxTool.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxTool.prototype, "isCompact", {
        get: function () {
            return this.props.isCompact;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorToolboxTool.prototype.getStateElement = function () {
        return this.item;
    };
    SurveyCreatorToolboxTool.prototype.render = function () {
        var _this = this;
        var item = this.item;
        var itemComponent = ReactElementFactory.Instance.createElement(this.model.itemComponent, {
            item: item,
            creator: this.creator,
            parentModel: this.creator.toolbox,
            model: this.model,
            isCompact: this.isCompact
        });
        return (React.createElement("div", { className: item.css, key: item.id, ref: this.rootRef },
            (item.needSeparator && !this.creator.toolbox.showCategoryTitles) ? (React.createElement("div", { className: "svc-toolbox__category-separator" })) : null,
            React.createElement("div", { className: "svc-toolbox__tool-content sv-action__content", onPointerDown: function (event) {
                    event.persist();
                    _this.model.onPointerDown(event);
                } }, itemComponent)));
    };
    SurveyCreatorToolboxTool.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.item.updateModeCallback = undefined;
    };
    SurveyCreatorToolboxTool.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        this.item.updateModeCallback = function (mode, callback) {
            queueMicrotask(function () {
                if (ReactDOM["flushSync"]) {
                    ReactDOM["flushSync"](function () {
                        _this.item.mode = mode;
                    });
                }
                else {
                    _this.item.mode = mode;
                }
                queueMicrotask(function () {
                    callback(mode, _this.rootRef.current);
                });
            });
        };
        this.item.afterRender();
    };
    return SurveyCreatorToolboxTool;
}(CreatorModelElement));
export { SurveyCreatorToolboxTool };
var SurveyCreatorToolboxItem = /** @class */ (function (_super) {
    __extends(SurveyCreatorToolboxItem, _super);
    function SurveyCreatorToolboxItem(props) {
        return _super.call(this, props) || this;
    }
    SurveyCreatorToolboxItem.prototype.getUpdatedModelProps = function () {
        return ["creator", "item"];
    };
    Object.defineProperty(SurveyCreatorToolboxItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxItem.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxItem.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorToolboxItem.prototype.getStateElement = function () {
        return this.model;
    };
    SurveyCreatorToolboxItem.prototype.render = function () {
        var _this = this;
        var banner = (this.props.isCompact ?
            React.createElement("span", { className: "svc-toolbox__item-banner", onClick: function (event) {
                    event.persist();
                    _this.model.click(event);
                } },
                React.createElement(SvgIcon, { size: "auto", iconName: this.item.iconName, className: "svc-toolbox__item-icon", title: this.item.tooltip }),
                React.createElement("span", null, this.item.title))
            :
                null);
        var item = attachKey2click(React.createElement("div", { className: this.item.renderedCss, tabIndex: 0, role: "button", "aria-label": this.item.tooltip, onClick: function (event) {
                event.persist();
                _this.model.click(event);
            } },
            React.createElement("span", { className: "svc-toolbox__item-container" }, !!this.item.iconName ? React.createElement(SvgIcon, { size: "auto", iconName: this.item.iconName, className: "svc-toolbox__item-icon" }) : null),
            (this.props.isCompact ?
                null
                :
                    React.createElement("span", { className: "svc-toolbox__item-title" }, this.item.title))));
        return (React.createElement(React.Fragment, null,
            item,
            banner));
    };
    return SurveyCreatorToolboxItem;
}(CreatorModelElement));
export { SurveyCreatorToolboxItem };
ReactElementFactory.Instance.registerElement("svc-toolbox-item", function (props) {
    return createElement(SurveyCreatorToolboxItem, props);
});
